<template>
  <ArticleParagraph
    v-if="text"
    :title="title"
    :text="text"
    :speech="currentText"
    :current="current" />
</template>

<script>
import ArticleParagraph from '@/components/ui/ArticleParagraph'
import { mapGetters } from 'vuex'
export default {
  name: 'ArticleText',
  components: {
    ArticleParagraph
  },
  props: {
    title: {
      type: String
    },
    text: {
      type: String
    },
    track: {
      type: Number,
      required: true
    },
    poiId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      currentPoiId: 'speech/currentPoiId',
      currentText: 'speech/currentText',
      currentIndex: 'speech/currentIndex'
    }),
    current () {
      return this.track - 1 === this.currentIndex && this.currentPoiId === this.poiId
    }
  }
}
</script>
